export default "__VITE_ASSET__a24822f7__"